<template>
  <div>
    <v-select :clearable="false" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :input-id="inputId" :options="departments" :reduce="department => department.code"
              :taggable="false" :value="value" label="name"
              placeholder="Choisir le département concerné" @input="$emit('input', $event)">
      <template #option="department">{{ department.name }} ({{ department.code }})</template>
      <template #no-options>Aucun département trouvé.</template>
    </v-select>
  </div>
</template>
<script>
import vSelect from 'vue-select';

export default {
  components: {vSelect},
  props: {
    value: {type: String, default: ''},
    inputId: {type: String, default: 'concerned_department'},
    departments: {type: Array, default: () => [],}
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
